import React from "react";
// Rule Block page

// Default
import { Handle, Position } from "@xyflow/react";

// Mui
import Card from "@mui/material/Card";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import { IconButton } from "@mui/material";
import { Edit, Delete } from "@mui/icons-material";
import { toTitleCase } from "../../utils/helper";

const RuleBlock = ({
  data,
  onEdit,
  onDelete,
}: {
  data: any;
  onEdit: () => void;
  onDelete: () => void;
}) => {
  return (
    <Card
      className="rule-block-header"
      sx={{
        width: "auto",
        borderRadius: "8px",
        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
        overflow: "hidden",
        backgroundColor:
          data?.addInfo?.bgColor ||
          "linear-gradient(180deg, #1976d2 0%, #0396FF 100%)",
        padding: "10px",
        // border: "1px solid #555",
        color: "white",
      }}
    >
      {/* Header */}

      <Stack direction={"row"} gap={"5px"} alignItems={"center"}>
        {data?.addInfo?.iconUrl ? (
          <img
            src={data?.addInfo?.iconUrl}
            alt="icon"
            style={{ width: 18, height: 18 }}
          />
        ) : (
          <span className="material-icons" style={{ fontSize: 18 }}>
            {data?.addInfo?.icon}
          </span>
        )}

        <Typography variant="body1" color={"white"}>
          {toTitleCase(data?.ruleName) || "Unnamed Block"}
        </Typography>
        <Box className="hover-buttons">
          <IconButton
            onClick={onEdit}
            sx={{
              color: "white",
              background:
                data?.addInfo?.bgColor ||
                "linear-gradient(180deg, #1976d2 0%, #0396FF 100%)",
              padding: "5px",
              "&:hover": {
                background:
                  data?.addInfo?.bgColor ||
                  "linear-gradient(180deg, #1976d2 0%, #0396FF 100%)",
              },
            }}
          >
            <Edit style={{ fontSize: 14 }} />
          </IconButton>
          <IconButton
            onClick={onDelete}
            sx={{
              color: "white",
              background:
                data?.addInfo?.bgColor ||
                "linear-gradient(180deg, #1976d2 0%, #0396FF 100%)",
              padding: "5px",
              "&:hover": {
                background:
                  data?.addInfo?.bgColor ||
                  "linear-gradient(180deg, #1976d2 0%, #0396FF 100%)",
              },
            }}
          >
            <Delete style={{ fontSize: 14 }} />
          </IconButton>
        </Box>
      </Stack>

      {/* <Box
        sx={{
          textAlign: "center",
          padding: "5px",
          background:
            data?.addInfo?.bgColor ||
            "linear-gradient(180deg, #1976d2 0%, #0396FF 100%)",
        }}
      >
        <Typography
          variant="body1"
          color="#FFFFFF"
          fontWeight={600}
          fontSize={"12px"}
        >
          {toTitleCase(data?.ruleName) || "Unnamed Block"}
        </Typography>
      </Box> */}

      {/* <Stack
        padding={"5px"}
        textAlign={"center"}
        direction={"column"}
        gap={"7px"}
      >
        {data.attributes && data.attributes.length > 0 ? (
          data.attributes.map((attr, index) => (
            <Stack
              key={index}
              direction={"flex"}
              justifyContent={"space-between"}
              alignItems={"center"}
            >
              <Typography variant="body2" fontSize={"9px"} fontWeight={600}>
                {attr.label}:
              </Typography>
              <Typography variant="body2" fontSize={"9px"}>
                {attr.value || "Not Set"}
              </Typography>
            </Stack>
          ))
        ) : (
          <Typography variant="body2" fontSize={"9px"}>
            No attributes configured
          </Typography>
        )}
      </Stack> */}

      {/* Handles */}
      <Handle type="target" position={Position.Left} style={styles.handle} />
      <Handle type="source" position={Position.Right} style={styles.handle} />
    </Card>
  );
};

const styles = {
  handle: {
    width: "10px",
    height: "10px",
    background: "#555",
    borderRadius: "50%",
  },
};

export default RuleBlock;
